export function useChiliPiper() {
  function initScript() {
    window.open(
      "https://www.sase.checkpoint.com/demo-cp?utm_source=sase-platform&utm_medium=start-now",
      "_blank"
    );
  }
  return initScript;
}
